import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActionResultItemFsDetailsResponse } from '@portal/models/actionResultItemFsDetailsResponse';
import { BuilderInfoService } from '@portal/builder';
import { getHttpParams, replaceId } from '@portal/core';
import { clientContext } from '../client.context';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private readonly http = inject(HttpClient);
  private readonly builderInfoService = inject(BuilderInfoService);

  getItemById(id: number) {
    const url = replaceId(clientContext.filter.itemById, id);

    return this.http.get<ActionResultItemFsDetailsResponse>(url, { params: this.getParamsWithIdCurrency() });
  }

  private getParamsWithIdCurrency(id?: number) {
    const params = { currency: this.builderInfoService.currency, skipErrorHandling: true };

    return getHttpParams(id ? { ...params, ids: `${id}` } : params);
  }
}
